module.exports = {
    Environment: process.env.REACT_PUBLIC_ENVIRONMENT,
    BaseURL: process.env.REACT_APP_API_BASE_URL,
};
